import React, { useState, useEffect, useCallback } from "react";
import clsx from "clsx";
import CustomDrawer from "../CustomComponents/CustomDrawer/CustomDrawer";
import CustomAppBar from "../CustomComponents/CustomAppBar/CustomAppBar";
import CustomToolbar from "../CustomComponents/CustomToolbar/CustomToolbar";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import CustomList from "../CustomComponents/CustomList/CustomList";
import CustomLink from "../CustomComponents/CustomLink/CustomLink";
import CustomDivider from "../CustomComponents/CustomDivider/CustomDivider";
import CustomIconButton from "../CustomComponents/CustomIconButton/CustomIconButton";
import CustomListItemIcon from "../CustomComponents/CustomListItemIcon/CustomListItemIcon";
import CustomListItem from "../CustomComponents/CustomListItem/CustomListItem";
import CustomListItemText from "../CustomComponents/CustomListItemText/CustomListItemText";
import { CustomMenuIcon, CustomCloseIcon, CustomExpandMoreIcon } from "../CustomComponents/CustomIcon/CustomIcon";
import { useStyles } from "../../assets/jss/Layout";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Logo from "../../assets/images/Logo.png";
import LogoAdmin from "../../assets/images/logo-admin.png";
import Dashboard from "../../assets/images/Dashboard.svg";
import WallofLegend from "../../assets/images/WallofLegend.svg";
import CalendarIcon from "../../assets/images/calendar.svg";
import CEIcon from "../../assets/images/CEIcon.svg";
import CEIconActive from "../../assets/images/CEIconActive.svg";
import AdminIcon from "../../assets/images/admin.svg";
import AdminIconActive from "../../assets/images/adminActive.svg";
import DashboardActive from "../../assets/images/DashboardBlack.svg";
import WallofLegendActive from "../../assets/images/WallofLegendBlack.svg";
import NotificationIcon from "../../assets/images/bell.svg";
import Locator from "../../assets/images/LocatorIcon.svg";
import LocatorActive from "../../assets/images/LocatorBlack.svg";
import CustomAvatar from "../CustomComponents/CustomAvatar/CustomAvatar";
import CustomButton from "../CustomComponents/CustomButton/CustomButton";
import CustomMenu from "../CustomComponents/CustomMenu/CustomMenu";
import CustomMenuItem from "../CustomComponents/CustomMenuItem/CustomMenuItem";
import IconButton from '@material-ui/core/IconButton';
import { NavLink } from "react-router-dom";
import { logOutUser, getStartDate, getEndDate, getSession, getUserData, getDefaultDates, setCurrentGroupPreference, getUserRBAC, getImpersonationDriver, getCompaEnabledForView, getHierarchyGroupList, setBrakingEventIndex, setCorneringEventIndex, setDistractionEventIndex, setSpeedIndex, setSpeedZoneIndex, setAccelerationEventIndex } from "../../services/LocalStorageService";
import AnalyticsExports from "../../assets/images/Report.svg";
import AnalyticsExportsActive from "../../assets/images/ReportBlack.svg";
import Events from "../../assets/images/Events.svg";
import EventsActive from "../../assets/images/EventsBlack.svg";
import UserDetails from "../../assets/images/Events.svg";
import UserDetailsActive from "../../assets/images/EventsBlack.svg";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PageLoader from "../PageLoader/PageLoader";
import CustomPopover from "../CustomComponents/CustomPopover/CustomPopover";
import CustomDateRange from "../CustomComponents/CustomDateRange/CustomDateRange";
import NotificationBar from "../NotificationBar/NotificationBar";
import CustomTypography from "../CustomComponents/CustomTypography/CustomTypography";
import HelpPopup from "../HelpPopup/HelpPopup";
import CustomTooltip from "../CustomComponents/CustomTooltip/CustomTooltip";
import CustomClickAwayListener from "../CustomComponents/CustomClickAwayListener/CustomClickAwayListener";
import { changeSession } from "../../services/ChangeSessionService";
import Footer from "../Footer/Footer";
import { EntityAccess, RBAC_CODE, Role } from "../../config/app-globals.enum";

import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getInitialsUser } from "../../assets/helperFunctions";
import { getContentData } from "../../services/LearningAPI";
import SearchBar from "../SearchBar/SearchBar";
import qs from "querystring";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import GroupMenu from "./GroupMenu";

const Layout = React.forwardRef((props: any, ref: any) => {
  const params = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const [getRBAC] = React.useState(getUserRBAC(null, props));
  const isIpadPortraitDown = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [userAnchorEl, setUserAnchorEl] = useState(null);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  // const [adminLink] = React.useState(process.env.REACT_APP_API_URL);
  const [startDate1] = React.useState(getStartDate);
  const [endDate1] = React.useState(getEndDate);
  const [userData] = React.useState(getUserData);
  const [userSession] = React.useState(getSession);
  const [currentURL, setCurrentURL] = useState("");
  const [openHelpPopUp, setOpenHelpPopUp] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationLoading, setNotificationLoading] = useState(true);
  const _defaultDates = getDefaultDates();
  const [defaultDates] = useState(_defaultDates);
  const [isSessionValid, setIsSessionValid] = useState(true);
  const [statusCode, setStatusCode] = useState(null);
  const [isAdminModule] = useState(props.isAdminModule);
  const [isHeaderSearch] = useState(props.isHeaderSearch);
  const [adminSearchKey, setAdminSearchKey] = useState(null);
  const [adminSearchType, setAdminSearchType] = useState(null);
  const [isCompaEnabledForView] = React.useState(getCompaEnabledForView);
  const [isMapScreen] = React.useState(props.isMapScreen ? props.isMapScreen : false);
  const [groupHierarchyObj, setGroupHierarchyObj] = useState(null);

  const Popup = ['dashboard', 'analytics', 'walloflegends', 'engagement', 'events', 'userdetails', 'exports', 'locator'];
  const handleHelpIcon = () => {
    let currentURL = '';
    let url = props.children.props.location.pathname;
    for (let i = 0; i < Popup.length; i++) {
      if (url.includes(Popup[i])) {
        currentURL = Popup[i];
      }
    }
    setCurrentURL(currentURL);
    setOpenHelpPopUp(!openHelpPopUp);
  };

  const handleOnPopUpCloseFunc = () => {
    setOpenHelpPopUp(!openHelpPopUp);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (group) => {
    setAnchorEl(null);
    if (group.id && group.name) setSelectedCompany(group, userData.Token);
  };

  const handleUserClick = (event) => {
    setUserAnchorEl(event.currentTarget);
  };

  const handleNotificationClick = (event) => {
    setNotificationOpen(!notificationOpen);
  };

  const handleNotificationClose = (event) => {
    setNotificationOpen(false);
  };

  //====
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====

  useEffect(() => {

    async function loadData() {
      setStatusValue(null);
      setAlertMessage("");
      setIsAlertOpen(false);
      setNotificationLoading(true);
      const data = await getContentData("NOTIFICATION", userData.id, 1, params);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        if (
          data.content &&
          data.content.contentList &&
          data.content.contentList.length
        ) {
          setNotifications([...notifications, ...data.content.contentList]);
        }
        setNotificationLoading(false);
      } else {
        setNotificationLoading(false);
        changeApiStatusCodeFunc(data.status);
      }
    }

    if (
      getRBAC &&
      getRBAC.find(
        (item) =>
          item.entityCode === RBAC_CODE.NOTIFICATION_POPUP_VIEW &&
          item.isAccessible === EntityAccess.ALLOWED
      )
    ) {
      loadData();
    }
  }, [userData]);

  const handleUserClose = (text?: any) => {
    setUserAnchorEl(null);
    if (text === "logout") {
      logOutUser();
      history.replace("/login", { from: "/" });
    }
    if (text === "closeDriver") {
      window.close();
    }
  };

  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [groupNames, setGroup] = useState(null);
  const [selectedgroupNames, setSelectedGroup] = useState<any>(setSelectedCompanyName());
  const [impersonationUser, setImpersonationUser] = useState(null);

  function findObject(obj, id) {
    const result = findObjectAux([obj], id);
    return result;
  }
  function findObjectAux(arr, id) {
    if (arr !== undefined && arr !== null) {
      for (const obj of arr) {
        if (obj.id === id) return obj;
        const nestedObj = findObjectAux(obj.childGroups, id);
        if (nestedObj) return nestedObj;
      }
    }
  }

  function setSelectedCompanyName(group?: any) {
    if (userSession && userSession.currentGroupId) {
      let currentGroupId = userSession.currentGroupId;
      if (groupNames) {
        if (params.impersonationid) {
          currentGroupId = groupNames[0].id;
        }
        const result = findObject(groupHierarchyObj, currentGroupId);
        return result;
      }
    }
  }

  useEffect(() => {
    async function getImpersonationUser() {
      const data = await getHierarchyGroupList(params, userData.userGroupId);
      let obj = data.content;
      setGroupHierarchyObj(obj);
      let groupList: any[] = [];
      groupList.push(obj);
      if (!params.impersonationid) {
        // data.content.childGroups.push(obj);
        if (obj) {
          setGroup([obj]);
          const result = findObject(obj, userSession.currentGroupId);
          setSelectedGroup(result);
        }
      } else {
        setSelectedGroup(data[0]);
        const driverImpersonation = await getImpersonationDriver(params.impersonationid);
        setImpersonationUser(driverImpersonation[0].data);
      }
    }
    if (userSession) {
      getImpersonationUser();
    }
  }, [params])

  //====
  const [statusValue1, setStatusValue1] = React.useState();
  const [alertMessage1, setAlertMessage1] = React.useState("");
  const [isAlertOpen1, setIsAlertOpen1] = React.useState(false);
  const changeApiStatusCodeFunc1 = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue1(status.code);
      setAlertMessage1(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen1(true);
    }
  };
  //====
  const setSelectedCompany = (group: any, token?: any) => {
    setAnchorEl(null);
    setStatusValue1(null);
    setAlertMessage1("");
    setIsAlertOpen1(false);
    async function loadData(group) {
      const data = await changeSession({
        currentGroupId: group.id,
      }, params);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        setBrakingEventIndex(-1);
        setCorneringEventIndex(-1);
        setDistractionEventIndex(-1);
        setSpeedIndex(-1);
        setSpeedZoneIndex(-1);
        setAccelerationEventIndex(-1);
        if (data?.content?.groupPrefs) {
          let pref = data.content.groupPrefs;
          setCurrentGroupPreference(pref);
        }
        setSelectedCompanyName(group.name);
        handleSelect({ selection: { ...defaultDates, }, });
        if (isAdminModule) {
          history.push("/admin");
        } else {
          if (params.impersonationid) {
            history.push(`/dashboard/impersonation/${params.impersonationid}`);
          } else {
            history.push("/dashboard");
          }
        }
      } else {
        changeApiStatusCodeFunc1(data.status);
      }
    }
    loadData(group);
  };
  React.useEffect(() => {
    if (userSession) {
      const currentDate = new Date();
      const currentDateUTC = new Date(currentDate.toUTCString());
      const tokenExpiry = new Date(userSession.expiresOn);
      const tokenExpiryUTC = new Date(tokenExpiry.toUTCString());
      if (tokenExpiryUTC > currentDateUTC) {
        setIsSessionValid(true);
      } else {
        setStatusCode({
          status: {
            code: 401,
            message: t("YOUR_SESSION_EXPIRED_PLEASE_LOGIN_AGAIN"),
          },
        });
        setIsSessionValid(false);
        setTimeout(() => {
          logOutUser();
          history.replace("/login", {
            from: history.location,
          });
        }, 2000);
      }
    } else {
      setIsSessionValid(false);
      history.replace("/login", {
        from: history.location,
      });
    }
  }, [userSession]);

  const [dateRangeAnchorEl, setDateRangeAnchorEl] = React.useState(null);
  const handleClickDatePicker = (event) => {
    setDateRangeAnchorEl(event.currentTarget);
  };

  const handleCloseDatePicker = () => {
    setDateRangeAnchorEl(null);
    setSelectionRange({
      startDate: startDate1,
      endDate: endDate1,
      maxDate: new Date(),
      key: "selection",
      color: theme.palette.primary.main,
    });
  };

  const datePickerOpen = Boolean(dateRangeAnchorEl);
  const datePickerId = datePickerOpen ? "dateRangePopover" : undefined;

  const [selectionRange, setSelectionRange] = React.useState<any>({
    startDate: startDate1,
    endDate: endDate1,
    maxDate: new Date(),
    key: "selection",
    color: theme.palette.primary.main,
  });

  //====
  const [statusValue2, setStatusValue2] = React.useState();
  const [alertMessage2, setAlertMessage2] = React.useState("");
  const [isAlertOpen2, setIsAlertOpen2] = React.useState(false);
  const changeApiStatusCodeFunc2 = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue2(status.code);
      setAlertMessage2(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen2(true);
    }
  };
  //====

  const handleSelect = (ranges: any, isBtn?: any) => {
    let selectedStartDate = new Date(ranges.selection.startDate);
    let selectedEndDate = new Date(ranges.selection.endDate);

    selectedStartDate.setHours(0, 0, 0, 0);
    selectedEndDate.setHours(23, 59, 59, 999);

    const selection = {
      ...ranges.selection,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    };
    ranges = {
      selection: { ...selection },
    };

    setSelectionRange(ranges.selection);

    async function loadData() {
      setStatusValue2(null);
      setAlertMessage2("");
      setIsAlertOpen2(false);
      const data = await changeSession({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
      }, params);
      if (
        data &&
        (data.status.code === 0 ||
          data.status.code === 200 ||
          data.status.code === 201) &&
        data.content
      ) {
        setBrakingEventIndex(-1);
        setCorneringEventIndex(-1);
        setDistractionEventIndex(-1);
        setSpeedIndex(-1);
        setSpeedZoneIndex(-1);
        setAccelerationEventIndex(-1);
        window.location.reload();
      } else {
        changeApiStatusCodeFunc2(data.status);
      }
    }

    if (isBtn) {
      loadData();
    }
  };


  useEffect(() => {
    if (history.location.pathname === "/admin/search") {
      const adminSearchQueryParams = qs.parse(history.location.search);
      setAdminSearchKey(
        adminSearchQueryParams["?searchKey"]
          ? adminSearchQueryParams["?searchKey"]
          : null
      );
      setAdminSearchType(
        adminSearchQueryParams["searchType"]
          ? adminSearchQueryParams["searchType"]
          : null
      );
    }
  }, [history.location.pathname]);

  const [getRBAC_UserImpersonation] = React.useState(
    getUserRBAC(RBAC_CODE.USER_IMPERSONATION, props)
  );

  const [getRBAC_LocatorView] = React.useState(
    getUserRBAC(RBAC_CODE.LOCATOR_VIEW, props)
  );

  let anchorRef = React.createRef();
  const divRef = React.useRef();

  const [origin, setOrigin] = useState<any>({
    anchorOrigin: {
      vertical: 10,
      horizontal: "right",
    },
    transformOrigin: {
      vertical: 10,
      horizontal: "left",
    },
  });

  const handleNavClick = useCallback((link: any) => {
    setActiveLink(link);
    return () => {
      setActiveLink(null);
    }
  }, [activeLink]);

  return (
    <>
      {isSessionValid && userSession ? (
        <>
          <div className={clsx(classes.root)}>
            {openHelpPopUp && (
              <HelpPopup
                currentURL={currentURL}
                status={openHelpPopUp}
                handleOnPopUpClose={handleOnPopUpCloseFunc}
              />
            )}
            <CustomAppBar
              id="header"
              position="fixed"
              className={clsx(
                classes.appBar,
                { [classes.appBarShift]: open },
                isAdminModule && classes.adminModuleHeader
              )}
            >
              <CustomToolbar className={classes.toolbar}>
                <CustomClickAwayListener onClickAway={handleDrawerClose}>
                  {open ? (
                    <CustomIconButton
                      color="inherit"
                      aria-label="close drawer"
                      onClick={handleDrawerClose}
                      edge="start"
                      className={clsx(
                        classes.menuButton,
                        {
                          [classes.hide]: !open,
                        },
                        isAdminModule && classes.menuButtonAdmin
                      )}
                    >
                      <CustomCloseIcon
                        style={{ color: isAdminModule ? "#FFF" : "#080808" }}
                      />
                    </CustomIconButton>
                  ) : (
                    <CustomIconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleDrawerOpen}
                      edge="start"
                      className={clsx(
                        classes.menuButton,
                        {
                          [classes.hide]: open,
                        },
                        isAdminModule && classes.menuButtonAdmin
                      )}
                    >
                      <CustomMenuIcon />
                    </CustomIconButton>
                  )}
                </CustomClickAwayListener>
                <CustomBox
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexGrow={1}
                >
                  <CustomBox display="flex" alignItems="center">
                    <NavLink to={"/dashboard"}>
                      <img
                        src={isAdminModule ? LogoAdmin : Logo}
                        alt="Logo"
                        className={classes.logo}
                      />
                    </NavLink>
                    {params.impersonationid ? (
                      isIpadPortraitDown ? (
                        <CustomTooltip
                          title={
                            t("VIEWING_AS_DRIVER") +
                            (impersonationUser
                              ? impersonationUser.firstName +
                              (impersonationUser.lastName
                                ? " " + impersonationUser.lastName
                                : "")
                              : null)
                          }
                          placement="bottom"
                        >
                          <IconButton
                            size="medium"
                            onClick={() => {
                              window.close();
                            }}
                            className={classes.closeWindowIpad}
                            aria-label="delete"
                          >
                            <CloseIcon />
                          </IconButton>
                        </CustomTooltip>
                      ) : (
                        <CustomButton
                          className={classes.closeWindow}
                          onClick={() => {
                            window.close();
                          }}
                          endIcon={<CloseIcon />}
                        >
                          {t("VIEWING_AS_DRIVER")}{" "}
                          {impersonationUser
                            ? impersonationUser.firstName +
                            (impersonationUser.lastName
                              ? " " + impersonationUser.lastName
                              : "")
                            : null}
                        </CustomButton>
                      )
                    ) : null}
                  </CustomBox>
                  {!isIpadPortraitDown &&
                    isHeaderSearch &&
                    getRBAC &&
                    getRBAC.find(
                      (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_SEARCH_BAR_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                    ) ? (
                    <CustomGrid
                      container
                      spacing={10}
                      justifyContent="center"
                    >
                      <CustomGrid item xs={12} lg={8} md={8}>
                        <SearchBar
                          searchKey={adminSearchKey}
                          searchType={adminSearchType}
                          size="small"
                        />
                      </CustomGrid>
                    </CustomGrid>
                  ) : null}
                  <CustomBox
                    display="flex"
                    alignItems="center"
                    flexDirection="row"
                  >
                    {!isAdminModule && (
                      <CustomBox
                        className={classes.helpIcon}
                        onClick={handleHelpIcon}
                      >
                        <CustomBox
                          className={classes.helpIconPulse}
                        ></CustomBox>
                      </CustomBox>
                    )}
                    {!isIpadPortraitDown && (
                      <>
                        {!isAdminModule && (
                          <>
                            <CustomBox
                              mx={1}
                              px={2}
                              className={classes.dateSet}
                              onClick={handleClickDatePicker}
                              aria-describedby={datePickerId}
                            >
                              {startDate1 &&
                                moment(startDate1).format("DD MMM")}{" "}
                              -{" "}
                              {endDate1 && moment(endDate1).format("DD MMM")}
                              <span className={classes.dateSetIcon}>
                                <img src={CalendarIcon} alt="" />
                              </span>
                            </CustomBox>
                            <CustomPopover
                              style={{ marginTop: 40 }}
                              id={datePickerId}
                              open={datePickerOpen}
                              anchorEl={dateRangeAnchorEl}
                              onClose={handleCloseDatePicker}
                              anchorOrigin={origin.anchorOrigin as Number}
                              transformOrigin={
                                origin.transformOrigin as Number
                              }
                            >
                              <CustomDateRange
                                ranges={[selectionRange]}
                                maxDate={new Date()}
                                onChange={($event) =>
                                  handleSelect($event, false)
                                }
                              />
                              <div className={classes.dropdownActionButton}>
                                <CustomButton
                                  className={classes.primaryButtonSm}
                                  onClick={() =>
                                    handleSelect(
                                      { selection: selectionRange },
                                      true
                                    )
                                  }
                                >
                                  {t("APPLY")}
                                </CustomButton>
                              </div>
                            </CustomPopover>
                          </>
                        )}
                        <CustomBox>
                          <CustomButton
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClick}
                            className={clsx(
                              classes.headerRightMenu,
                              isAdminModule && classes.headerRightMenuLight
                            )}
                          >

                            {selectedgroupNames && selectedgroupNames.name}
                            {groupNames && groupNames.length && (
                              <CustomExpandMoreIcon
                                className={classes.headerRightMenuIcon}
                              />
                            )}
                          </CustomButton>
                          {groupNames && groupNames.length > 0 && (
                            <CustomMenu
                              id="simple-menu"
                              anchorEl={anchorEl}
                              keepMounted
                              open={Boolean(anchorEl)}
                              onClose={handleClose}
                              PopoverClasses={{
                                paper: classes.groupNamesMenu,
                              }}
                            >
                              <CustomMenuItem
                                className={classes.selectedGroupName}
                              >
                                {selectedgroupNames &&
                                  selectedgroupNames.name}
                              </CustomMenuItem>
                              <GroupMenu groupObj={groupNames} selectedGroup={selectedgroupNames} setSelectedCompany={setSelectedCompany} />
                            </CustomMenu>
                          )}
                        </CustomBox>
                      </>
                    )}
                    {!isAdminModule &&
                      getRBAC &&
                      getRBAC.find(
                        (item) =>
                          item.entityCode ===
                          RBAC_CODE.NOTIFICATION_POPUP_VIEW &&
                          item.isAccessible === EntityAccess.ALLOWED
                      ) ? (
                      <CustomBox mx={1} px={2} className={classes.border}>
                        <div
                          className={classes.notification}
                          onClick={handleNotificationClick}
                        >
                          <img
                            alt="Notifications"
                            src={NotificationIcon}
                            className={classes.notificationIcon}
                          />
                          {notifications && notifications.length > 0 && (
                            <span className={classes.notificationDot}>
                              <span
                                className={clsx(
                                  classes.notificationDotInner,
                                  notifications.length > 0 &&
                                  classes.notificationDotEnable
                                )}
                              ></span>
                            </span>
                          )}
                        </div>
                      </CustomBox>
                    ) : null}
                    <CustomBox className={classes.avatar}>
                      <CustomButton
                        aria-controls="user-avatar"
                        aria-haspopup="true"
                        onClick={handleUserClick}
                        className={classes.headerRightMenu}
                      >
                        <CustomAvatar className={classes.avatar}>
                          {params.impersonationid
                            ? getInitialsUser(impersonationUser)
                            : getInitialsUser(userData)}
                        </CustomAvatar>
                      </CustomButton>
                      <CustomMenu
                        id="user-avatar"
                        anchorEl={userAnchorEl}
                        keepMounted
                        open={Boolean(userAnchorEl)}
                        onClose={() => handleUserClose()}
                        className={clsx(
                          classes.layoutProfileMenu,
                          getRBAC &&
                            getRBAC.find(
                              (item) =>
                                item.entityCode ===
                                RBAC_CODE.USER_DETAIL_VIEW &&
                                item.isAccessible === EntityAccess.ALLOWED &&
                                item.isGroupScope === EntityAccess.NOT_ALLOWED
                            )
                            ? classes.avatarProfileAdmin
                            : null
                        )}
                      >
                        <CustomMenuItem className={classes.avatarProfile}>
                          {getRBAC &&
                            getRBAC.find(
                              (item) =>
                                item.entityCode ===
                                RBAC_CODE.USER_DETAIL_VIEW &&
                                item.isAccessible === EntityAccess.ALLOWED &&
                                item.isGroupScope !== EntityAccess.ALLOWED
                            ) ? (
                            <CustomLink
                              className={classes.avatarProfileLink}
                              href={
                                params.impersonationid
                                  ? `/impersonation/${params.impersonationid}/userdetails/${params.impersonationid}`
                                  : `/userdetails/${userData.id}`
                              }
                            >
                              <CustomAvatar className={classes.driverAvatar}>
                                {params.impersonationid
                                  ? getInitialsUser(impersonationUser)
                                  : getInitialsUser(userData)}
                              </CustomAvatar>
                              <CustomTypography
                                className={classes.avatarUserName}
                              >
                                {params.impersonationid && impersonationUser
                                  ? impersonationUser.firstName +
                                  " " +
                                  impersonationUser.lastName
                                  : userData.firstName +
                                  " " +
                                  userData.lastName}
                              </CustomTypography>
                              <CustomTypography
                                className={classes.avatarEmail}
                              >
                                {params.impersonationid && impersonationUser
                                  ? impersonationUser.email
                                  : userData.email}
                              </CustomTypography>
                            </CustomLink>
                          ) : (
                            <>
                              <CustomAvatar className={classes.driverAvatar}>
                                {params.impersonationid
                                  ? getInitialsUser(impersonationUser)
                                  : getInitialsUser(userData)}
                              </CustomAvatar>
                              <CustomTypography
                                className={classes.avatarUserName}
                              >
                                {params.impersonationid && impersonationUser
                                  ? impersonationUser.firstName +
                                  " " +
                                  impersonationUser.lastName
                                  : userData.firstName +
                                  " " +
                                  userData.lastName}
                              </CustomTypography>
                              <CustomTypography
                                className={classes.avatarEmail}
                              >
                                {params.impersonationid && impersonationUser
                                  ? impersonationUser.email
                                  : userData.email}
                              </CustomTypography>
                            </>
                          )}
                        </CustomMenuItem>
                        <CustomMenuItem>
                          <CustomButton
                            onClick={() =>
                              params.impersonationid
                                ? handleUserClose("closeDriver")
                                : handleUserClose("logout")
                            }
                            variant="contained"
                            color="primary"
                            fullWidth
                            className={classes.avatarLogout}
                          >
                            {params.impersonationid
                              ? t("CLOSE_DRIVER_VIEW")
                              : t("SIGN_OUT")}
                          </CustomButton>
                        </CustomMenuItem>
                      </CustomMenu>
                    </CustomBox>
                  </CustomBox>
                </CustomBox>
              </CustomToolbar>
            </CustomAppBar>
            <CustomDrawer
              variant="permanent"
              className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
              })}
              classes={{
                paper: clsx({
                  [classes.drawerOpen]: open,
                  [classes.drawerClose]: !open,
                }),
              }}
            >
              <div className={classes.toolbar}></div>
              <CustomDivider />
              <CustomList className={clsx(classes.list, open ? classes.listOpen : "")}              >
                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.DASHBOARD_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={
                      params.impersonationid
                        ? `/dashboard/impersonation/${params.impersonationid}`
                        : "/dashboard"
                    }
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(Dashboard);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === Dashboard ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("DASHBOARD")} placement="right">
                      <CustomListItem button key="Dashboard">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === Dashboard
                                ? DashboardActive
                                : Dashboard
                            }
                            alt={t("DASHBOARD")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("DASHBOARD")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}
                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.WOL_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={
                      params.impersonationid
                        ? `/impersonation/${params.impersonationid}/walloflegends`
                        : "/walloflegends"
                    }
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(WallofLegend);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === WallofLegend ? classes.active : null
                    )}
                  >
                    <CustomTooltip
                      title={t("WALL_OF_LEGENDS")}
                      placement="right"
                    >
                      <CustomListItem button key="WallofLegend">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === WallofLegend
                                ? WallofLegendActive
                                : WallofLegend
                            }
                            alt={t("WALL_OF_LEGENDS")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("WALL_OF_LEGENDS")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}
                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.CE_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={
                      params.impersonationid
                        ? `/impersonation/${params.impersonationid}/engagement`
                        : "/engagement"
                    }
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(CEIcon);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === CEIcon ? classes.active : null
                    )}
                  >
                    <CustomTooltip
                      title={t("CONTENT_ENGAGEMENT")}
                      placement="right"
                    >
                      <CustomListItem button key="Engagement">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === CEIcon ? CEIconActive : CEIcon
                            }
                            alt={t("CONTENT_ENGAGEMENT")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("ENGAGEMENT")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}
                {getRBAC &&
                  (getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.ANALYTICS_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ||
                    getRBAC.find(
                      (item) =>
                        item.entityCode === RBAC_CODE.EXPORT_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                    )) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={
                      getRBAC.find(
                        (item) =>
                          item.entityCode === RBAC_CODE.EXPORT_VIEW &&
                          item.isAccessible === EntityAccess.ALLOWED
                      ) &&
                        !getRBAC.find(
                          (item) =>
                            item.entityCode === RBAC_CODE.ANALYTICS_VIEW &&
                            item.isAccessible === EntityAccess.ALLOWED
                        )
                        ? params.impersonationid
                          ? `/impersonation/${params.impersonationid}/exports`
                          : "/exports"
                        : params.impersonationid
                          ? `/impersonation/${params.impersonationid}/analytics`
                          : "/analytics"
                    }
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(AnalyticsExports);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === AnalyticsExports ? classes.active : null
                    )}
                  >
                    <CustomTooltip
                      title={
                        getRBAC.find(
                          (item) =>
                            item.entityCode === RBAC_CODE.EXPORT_VIEW &&
                            item.isAccessible === EntityAccess.ALLOWED
                        ) &&
                          !getRBAC.find(
                            (item) =>
                              item.entityCode === RBAC_CODE.ANALYTICS_VIEW &&
                              item.isAccessible === EntityAccess.ALLOWED
                          )
                          ? t("EXPORTS")
                          : t("ANALYTICS")
                      }
                      placement="right"
                    >
                      <CustomListItem button key="AnalyticsExports">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === AnalyticsExports
                                ? AnalyticsExportsActive
                                : AnalyticsExports
                            }
                            alt={
                              getRBAC.find(
                                (item) =>
                                  item.entityCode === RBAC_CODE.EXPORT_VIEW &&
                                  item.isAccessible === EntityAccess.ALLOWED
                              ) &&
                                !getRBAC.find(
                                  (item) =>
                                    item.entityCode ===
                                    RBAC_CODE.ANALYTICS_VIEW &&
                                    item.isAccessible === EntityAccess.ALLOWED
                                )
                                ? t("EXPORTS")
                                : t("ANALYTICS")
                            }
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={
                            getRBAC.find(
                              (item) =>
                                item.entityCode === RBAC_CODE.EXPORT_VIEW &&
                                item.isAccessible === EntityAccess.ALLOWED
                            ) &&
                              !getRBAC.find(
                                (item) =>
                                  item.entityCode ===
                                  RBAC_CODE.ANALYTICS_VIEW &&
                                  item.isAccessible === EntityAccess.ALLOWED
                              )
                              ? t("EXPORTS")
                              : t("ANALYTICS")
                          }
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.EVENTS_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={{
                      pathname: "/events",
                      hash: "tabSPEEDING",
                    }}
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(Events);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === Events ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("EVENTS")} placement="right">
                      <CustomListItem button key="Events">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === Events ? EventsActive : Events
                            }
                            alt={t("EVENTS")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("EVENTS")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.USER_DETAIL_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED &&
                      item.isGroupScope !== EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={{
                      pathname: params.impersonationid
                        ? `/impersonation/${params.impersonationid}/userdetails/${params.impersonationid}`
                        : `/userdetails/${userData.id}`,
                    }}
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      handleNavClick(UserDetails);
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === UserDetails ? classes.active : null
                    )}
                  >
                    <CustomTooltip
                      title={t("DRIVER_EVENTS")}
                      placement="right"
                    >
                      <CustomListItem button key="UserDetails">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === UserDetails
                                ? UserDetailsActive
                                : UserDetails
                            }
                            alt={t("DRIVER_EVENTS")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("DRIVER_EVENTS")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {/* /locator for admin */}

                {userData.userRoleId !== Role.DRIVER &&
                  getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.LOCATOR_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED &&
                      item.isGroupScope === EntityAccess.ALLOWED &&
                      isCompaEnabledForView &&
                      isCompaEnabledForView === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={"/locator"}
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      /* setActiveLink(LocatorActive); */
                      handleNavClick(
                        LocatorActive
                      );
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === LocatorActive ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("LOCATOR")} placement="right">
                      <CustomListItem button key="Locator">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === LocatorActive
                                ? LocatorActive
                                : Locator
                            }
                            alt={t("LOCATOR")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("LOCATOR")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {/* /locator for user */}
                {userData.userRoleId === Role.DRIVER &&
                  getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.LOCATOR_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED &&

                      isCompaEnabledForView &&
                      isCompaEnabledForView === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={`/userdetails/${userData.id}#tabTrips`}
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      if (location.hash === "#tabTrips") {
                        /* setActiveLink(LocatorActive); */
                        handleNavClick(LocatorActive);
                      }
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === LocatorActive ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("LOCATOR")} placement="right">
                      <CustomListItem button key="Locator">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === LocatorActive
                                ? LocatorActive
                                : Locator
                            }
                            alt={t("LOCATOR")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("LOCATOR")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {/*locator for impersonation user */}
                {params.impersonationid &&
                  impersonationUser &&
                  impersonationUser.userRoleId === Role.DRIVER &&
                  getRBAC_LocatorView &&
                  getRBAC_LocatorView.entityCode === RBAC_CODE.LOCATOR_VIEW &&
                  getRBAC_LocatorView.isAccessible === EntityAccess.ALLOWED &&
                  isCompaEnabledForView &&
                  isCompaEnabledForView === EntityAccess.ALLOWED ? (
                  <NavLink
                    innerRef={anchorRef}
                    to={
                      "/impersonation/" +
                      impersonationUser.id +
                      "/userdetails/" +
                      impersonationUser.id +
                      "#tabTrips"
                    }
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (!match) {
                        return false;
                      }
                      if (location.hash === "#tabTrips") {
                        handleNavClick(LocatorActive);
                      }
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === LocatorActive ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("LOCATOR")} placement="right">
                      <CustomListItem button key="Locator">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === LocatorActive
                                ? LocatorActive
                                : Locator
                            }
                            alt={t("LOCATOR")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("LOCATOR")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}

                {getRBAC &&
                  getRBAC.find(
                    (item) =>
                      item.entityCode === RBAC_CODE.ADMIN_DASHBOARD_VIEW &&
                      item.isAccessible === EntityAccess.ALLOWED
                  ) ? (
                  <NavLink
                    innerRef={anchorRef}
                    to="/admin"
                    style={{ textDecoration: "none" }}
                    isActive={(match, location) => {
                      if (location.pathname === "/admin") {
                        handleNavClick(AdminIcon);
                      }
                    }}
                    className={clsx(
                      open ? classes.linkOpened : classes.linkClosed,
                      activeLink === AdminIcon ? classes.active : null
                    )}
                  >
                    <CustomTooltip title={t("ADMIN")} placement="right">
                      <CustomListItem button key="Admin">
                        <CustomListItemIcon>
                          <img
                            className={classes.imageIcon}
                            src={
                              activeLink === AdminIcon
                                ? AdminIconActive
                                : AdminIcon
                            }
                            alt={t("ADMIN")}
                          />
                        </CustomListItemIcon>
                        <CustomListItemText
                          primary={t("ADMIN")}
                          className={classes.iconText}
                        />
                      </CustomListItem>
                    </CustomTooltip>
                  </NavLink>
                ) : null}
              </CustomList>
            </CustomDrawer>
            <main
              className={clsx(
                classes.content,
                isMapScreen ? classes.contentMap : ""
              )}
            >
              <div className={classes.toolbar} />
              {isIpadPortraitDown &&
                isHeaderSearch &&
                getRBAC &&
                getRBAC.find(
                  (item) =>
                    item.entityCode === RBAC_CODE.ADMIN_SEARCH_BAR_VIEW &&
                    item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <CustomGrid container spacing={10} justifyContent="center">
                  <CustomGrid item xs={12} lg={8} md={8}>
                    <SearchBar
                      searchKey={adminSearchKey}
                      searchType={adminSearchType}
                      size="small"
                    />
                  </CustomGrid>
                </CustomGrid>
              ) : null}
              {isIpadPortraitDown && (
                <>
                  <div className={classes.mobileSubHeader}>
                    <CustomBox mx={1} px={0} className={classes.dateSet}>
                      <div className={classes.dateSetMobile}>
                        <div>
                          <div className={classes.dateSetMobileDate}>
                            {startDate1 && moment(startDate1).format("DD")}
                          </div>
                          <div className={classes.dateSetMobileMonth}>
                            {startDate1 && moment(startDate1).format("MMM")}
                          </div>
                        </div>
                        -
                        <div>
                          <div className={classes.dateSetMobileDate}>
                            {endDate1 && moment(endDate1).format("DD")}
                          </div>
                          <div className={classes.dateSetMobileMonth}>
                            {endDate1 && moment(endDate1).format("MMM")}
                          </div>
                        </div>
                      </div>
                      <div ref={divRef}>
                        <img
                          src={CalendarIcon}
                          aria-describedby="dateRangePopover1"
                          onClick={handleClickDatePicker}
                          className={classes.dateSetIcon}
                          alt=""
                        />
                        <CustomPopover
                          id="dateRangePopover"
                          open={datePickerOpen}
                          anchorEl={dateRangeAnchorEl}
                          onClose={handleCloseDatePicker}
                          anchorOrigin={origin.anchorOrigin as Number}
                          transformOrigin={origin.transformOrigin as Number}
                        >
                          <CustomDateRange
                            ranges={[selectionRange]}
                            maxDate={new Date()}
                            onChange={($event) => handleSelect($event)}
                          />
                          <div className={classes.dropdownActionButton}>
                            <CustomButton
                              className={classes.primaryButtonSm}
                              onClick={() =>
                                handleSelect(
                                  { selection: selectionRange },
                                  true
                                )
                              }
                            >
                              {t("APPLY")}
                            </CustomButton>
                          </div>
                        </CustomPopover>
                      </div>
                    </CustomBox>
                    <CustomBox className={classes.companyContainer}>
                      <CustomButton
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        className={clsx(
                          classes.headerRightMenu,
                          classes.headerRightMenuMobile
                        )}
                      >
                        {groupNames && groupNames.length
                          ? selectedgroupNames && selectedgroupNames.name
                          : userData.userGroupId}
                        {groupNames && groupNames.length && (
                          <CustomExpandMoreIcon
                            className={classes.headerRightMenuIcon}
                          />
                        )}
                      </CustomButton>
                      {groupNames && groupNames.length > 0 && (
                        <CustomMenu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {groupNames.map((company) => (
                            <CustomMenuItem
                              onClick={() => handleClose(company)}
                              key={company.id}
                            >
                              {company.name}
                            </CustomMenuItem>
                          ))}
                        </CustomMenu>
                      )}
                    </CustomBox>
                  </div>
                </>
              )}
              <CustomBox
                className={
                  isMapScreen ? classes.contentInnerMap : classes.contentInner
                }
              >
                {isSessionValid && props.children}
              </CustomBox>
            </main>
            {notificationOpen &&
              getRBAC.find(
                (item) =>
                  item.entityCode === RBAC_CODE.NOTIFICATION_POPUP_VIEW &&
                  item.isAccessible === EntityAccess.ALLOWED
              ) &&
              getRBAC.find(
                (item) =>
                  item.entityCode === RBAC_CODE.CONTENT_VIEW &&
                  item.isAccessible === EntityAccess.ALLOWED
              ) ? (
              <NotificationBar
                data={notifications}
                loading={notificationLoading}
                onClick={handleNotificationClose}
              />
            ) : null}
          </div>
          {isMapScreen === false && <Footer />}
        </>
      ) : (
        <>
          <PageLoader apiStatus={statusCode} />
        </>
      )}

      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
      <ErrorAlert
        code={statusValue1}
        message={alertMessage1}
        isOpen={isAlertOpen1}
        isClose={(isClose) => setIsAlertOpen1(!isClose)}
      />
      <ErrorAlert
        code={statusValue2}
        message={alertMessage2}
        isOpen={isAlertOpen2}
        isClose={(isClose) => setIsAlertOpen2(!isClose)}
      />
    </>
  );
});

export default Layout;
